import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './Navigation';
import LandingPage from './LandingPage';
import InterestCalculator from './InterestCalculator';
import GoalPlanner from './GoalPlanner';
import LTVCalculator from './LTVCalculator';
import RetirementCalculator from './RetirementCalculator';
import OpportunityCostCalculator from './OpportunityCostCalculator';
import HindsightSimulator from './components/HindsightSimulator';
import MyDashboard from './MyDashboard';
import UserGuide from './UserGuide';
import Disclaimer from './Disclaimer';
import AuthPage from './components/Auth';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import Footer from './Footer';
import DisclaimerModal from './DisclaimerModal';
import LightRays from './components/ui/LightRays';
import './components/ui/LightRays.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App relative">
          <div style={{ width: '100%', height: '500px', position: 'absolute', top: 0, left: 0, zIndex: 0, overflow: 'hidden', pointerEvents: 'none' }}>
            <LightRays
              raysOrigin="top-center"
              raysColor="#f6ad55"
              raysSpeed={1.2}
              lightSpread={0.7}
              rayLength={1.5}
              followMouse={true}
              mouseInfluence={0.05}
              noiseAmount={0.05}
              distortion={0.05}
            />
          </div>
          {/* New Navigation Component */}
          <Navigation />
          
          {/* Disclaimer Modal - Shows on first visit */}
          <DisclaimerModal />
          
          <main className="main-content">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/interest" element={<InterestCalculator />} />
              <Route path="/goal-planner" element={<GoalPlanner />} />
              <Route path="/ltv" element={<LTVCalculator />} />
              <Route path="/retirement" element={<RetirementCalculator />} />
              <Route path="/opportunity-cost" element={<OpportunityCostCalculator />} />
              <Route path="/hindsight-simulator" element={<HindsightSimulator />} />
              <Route path="/dashboard" element={<MyDashboard />} />
              <Route path="/guide" element={<UserGuide />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          
          {/* Footer with disclaimer notice */}
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;